<template>
     <v-layout align-center justify-center>
      <v-alert text color="teal" width="70%">
        <h3 class="headline">Description skipped for {{ SKU }}</h3>
        <div class="text-h6">
          Please, put this item to
          <span style="color: #ff3d00">
            {{ newLocation }}
          </span>
          box ant then click
          <span style="color: #ff3d00"> Proceed </span>
        </div>

        <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>

        <v-row align="center" no-gutters>
          <v-col class="grow">
            This operation with this item won't be counted into your daily
            descriptions amount. Click proceed once you put them into a correct
            box.
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="shrink">
            <v-btn color="teal" @click="changeLocation" style="color: white">
              Proceed
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-layout>
</template>

<script>
export default {
  name: "AlertLocationChange",
  props: {
    SKU: String,
    newLocation: String,
  },
  methods: {
    changeLocation() {
      this.$emit("changeLocation");
    },
  },
};
</script>